import {SidebarSection} from './SidebarSection'
import styles from './Reviewers.module.css'
import {SkeletonBox, SkeletonText} from '@primer/react/experimental'

type Props = {
  title: string
  placeholderRows?: number
}

/** Loading skeleton that mirrors the Reviewers sidebar section */
export function UserSectionSkeleton({title, placeholderRows = 3}: Props) {
  return (
    <SidebarSection title={title}>
      <ul className={styles.reviewerList}>
        {Array.from({length: placeholderRows}, (_, i) => (
          <li key={i} className={styles.reviewerRow}>
            <SkeletonBox className={styles.avatar} />
            <SkeletonText size="bodySmall" className={styles.name} />
            <SkeletonBox className={styles.indicator} />
          </li>
        ))}
      </ul>
    </SidebarSection>
  )
}
